const SCORE_300 = 300;
const SCORE_100 = 100;
const SCORE_50 = 50;
const SLIDER_TICK_BONUS = 10;
const SLIDER_REPEAT_BONUS = 20;
const SLIDER_END_BONUS = 30;
const SPIN_BONUS_SCORE = 1000;

class ScoreTracker {
  health;
  score = 0;
  combo = 0;
  maxCombo = 0;
  n300 = 0;
  n100 = 0;
  n50 = 0;
  misses = 0;

  constructor(health) {
    this.health = health;
  }

  incCombo() {
    this.combo += 1;
    this.maxCombo = Math.max(this.maxCombo, this.combo);
  }

  register(result, progress = 0) {
    if (result === 'spinner') {
      this.health?.apply('spinner', progress);
      if (progress >= 1) {
        this.score += SCORE_300;
        this.n300 += 1;
        this.incCombo();
      } else {
        this.score += Math.round(SCORE_300 * Math.max(progress, 0));
        this.misses += 1;
        this.combo = 0;
      }
      return;
    }
    if (result === 'spinBonus') {
      this.health?.apply('spinBonus');
      this.score += SPIN_BONUS_SCORE;
      return;
    }
    if (result !== 'sliderMiss') this.health?.apply(result);
    switch (result) {
      case 'perfect':
        this.score += SCORE_300;
        this.n300 += 1;
        this.incCombo();
        break;
      case 'great':
        this.score += SCORE_100;
        this.n100 += 1;
        this.incCombo();
        break;
      case 'good':
        this.score += SCORE_50;
        this.n50 += 1;
        this.incCombo();
        break;
      case 'tick':
        this.score += SLIDER_TICK_BONUS;
        this.n300 += 1;
        this.incCombo();
        break;
      case 'repeat':
        this.score += SLIDER_REPEAT_BONUS;
        this.n300 += 1;
        this.incCombo();
        break;
      case 'end':
        this.score += SLIDER_END_BONUS;
        this.n300 += 1;
        this.incCombo();
        break;
      case 'sliderMiss':
        // Slider ticks/repeats/tail misses do not affect score or combo
        break;
      default:
        this.misses += 1;
        this.combo = 0;
        break;
    }
  }

  get nObjects() {
    return this.n300 + this.n100 + this.n50 + this.misses;
  }

  get accuracy() {
    const denom = 300 * this.nObjects;
    if (denom === 0) return 0;
    const num = 300 * this.n300 + 100 * this.n100 + 50 * this.n50;
    return (num / denom) * 100;
  }

  get grade() {
    const objects = this.nObjects;
    if (objects === 0) return 'D';
    const ratio300 = this.n300 / objects;
    const ratio50 = this.n50 / objects;
    if (ratio300 === 1) return 'SS';
    if (ratio300 > 0.9 && ratio50 <= 0.01 && this.misses === 0) return 'S';
    if ((ratio300 > 0.8 && this.misses === 0) || ratio300 > 0.9) return 'A';
    if ((ratio300 > 0.7 && this.misses === 0) || ratio300 > 0.8) return 'B';
    if (ratio300 > 0.6) return 'C';
    return 'D';
  }
}

export default ScoreTracker;
